import type { SelectHTMLAttributes } from 'react';

export interface SelectOption {
  value: string;
  label: string;
}

interface Props extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'onChange' | 'value'> {
  value: string;
  options: SelectOption[];
  onChange: (value: string) => void;
  'aria-label': string;
}

export function Select({ value, options, onChange, className = '', ...rest }: Props) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={
        'rounded-md border border-[var(--co-border)] bg-[var(--co-surface)] px-2 py-1.5 text-[12px] ' +
        'text-[var(--co-text)] outline-none focus:border-[var(--co-brand)] disabled:opacity-50 ' +
        className
      }
      {...rest}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
